function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import hasInterface from '../../../../../hasInterface';
import MonotoneChain from './MonotoneChain';
import SweepLineEvent from './SweepLineEvent';
import EdgeSetIntersector from './EdgeSetIntersector';
import Collections from '../../../../../java/util/Collections';
import SegmentIntersector from './SegmentIntersector';
import ArrayList from '../../../../../java/util/ArrayList';
import List from '../../../../../java/util/List';
var SimpleMCSweepLineIntersector = /*#__PURE__*/function (_EdgeSetIntersector) {
  function SimpleMCSweepLineIntersector() {
    var _this;
    _classCallCheck(this, SimpleMCSweepLineIntersector);
    _this = _callSuper(this, SimpleMCSweepLineIntersector);
    SimpleMCSweepLineIntersector.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(SimpleMCSweepLineIntersector, _EdgeSetIntersector);
  return _createClass(SimpleMCSweepLineIntersector, [{
    key: "prepareEvents",
    value: function prepareEvents() {
      Collections.sort(this.events);
      for (var i = 0; i < this.events.size(); i++) {
        var ev = this.events.get(i);
        if (ev.isDelete()) {
          ev.getInsertEvent().setDeleteEventIndex(i);
        }
      }
    }
  }, {
    key: "computeIntersections",
    value: function computeIntersections() {
      if (arguments.length === 1) {
        var si = arguments[0];
        this.nOverlaps = 0;
        this.prepareEvents();
        for (var i = 0; i < this.events.size(); i++) {
          var ev = this.events.get(i);
          if (ev.isInsert()) {
            this.processOverlaps(i, ev.getDeleteEventIndex(), ev, si);
          }
          if (si.isDone()) {
            break;
          }
        }
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof SegmentIntersector && hasInterface(arguments[0], List) && hasInterface(arguments[1], List)) {
          var edges0 = arguments[0];
          var edges1 = arguments[1];
          var _si = arguments[2];
          this.addEdges(edges0, edges0);
          this.addEdges(edges1, edges1);
          this.computeIntersections(_si);
        } else if (typeof arguments[2] === 'boolean' && hasInterface(arguments[0], List) && arguments[1] instanceof SegmentIntersector) {
          var edges = arguments[0];
          var _si2 = arguments[1];
          var testAllSegments = arguments[2];
          if (testAllSegments) this.addEdges(edges, null);else this.addEdges(edges);
          this.computeIntersections(_si2);
        }
      }
    }
  }, {
    key: "addEdge",
    value: function addEdge(edge, edgeSet) {
      var mce = edge.getMonotoneChainEdge();
      var startIndex = mce.getStartIndexes();
      for (var i = 0; i < startIndex.length - 1; i++) {
        var mc = new MonotoneChain(mce, i);
        var insertEvent = new SweepLineEvent(edgeSet, mce.getMinX(i), mc);
        this.events.add(insertEvent);
        this.events.add(new SweepLineEvent(mce.getMaxX(i), insertEvent));
      }
    }
  }, {
    key: "processOverlaps",
    value: function processOverlaps(start, end, ev0, si) {
      var mc0 = ev0.getObject();
      for (var i = start; i < end; i++) {
        var ev1 = this.events.get(i);
        if (ev1.isInsert()) {
          var mc1 = ev1.getObject();
          if (!ev0.isSameLabel(ev1)) {
            mc0.computeIntersections(mc1, si);
            this.nOverlaps++;
          }
        }
      }
    }
  }, {
    key: "addEdges",
    value: function addEdges() {
      if (arguments.length === 1) {
        var edges = arguments[0];
        for (var i = edges.iterator(); i.hasNext();) {
          var edge = i.next();
          this.addEdge(edge, edge);
        }
      } else if (arguments.length === 2) {
        var _edges = arguments[0];
        var edgeSet = arguments[1];
        for (var _i = _edges.iterator(); _i.hasNext();) {
          var _edge = _i.next();
          this.addEdge(_edge, edgeSet);
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SimpleMCSweepLineIntersector;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(EdgeSetIntersector);
export { SimpleMCSweepLineIntersector as default };
SimpleMCSweepLineIntersector.constructor_ = function () {
  this.events = new ArrayList();
  this.nOverlaps = null;
};